const isBoolean = value => typeof value === "boolean";

export const transformHTPP = (data, backData) => {
  const userAgent = backData["userAgentJs"];

  return data.map(item => {
    const ratio = item.ratio.toFixed(2);
    if (item.id === "userAgent") {
      return {
        ...item,
        ratio,
        value: userAgent,
      };
    }
    if (isBoolean(backData[item.id])) {
      return { ...item, ratio, value: backData[item.id] };
    }
    return {
      ...item,
      ratio,
      value: (item.id && backData[item.id]) || item.value,
    };
  });
};
